import { render, staticRenderFns } from "./DependencyOccurenceInfoGroup.vue?vue&type=template&id=3fcf2450"
import script from "./DependencyOccurenceInfoGroup.vue?vue&type=script&lang=ts"
export * from "./DependencyOccurenceInfoGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DependencyOccurenceInfoItem: require('/app/components/Dependencies/Occurrence/DependencyOccurenceInfoItem.vue').default,UnavailableLabel: require('/app/components/Dependencies/Common/UnavailableLabel.vue').default,UILabel: require('/app/components/Common/UI2/Label/UILabel.vue').default,SeverityIndicator: require('/app/components/Dependencies/Common/SeverityIndicator.vue').default,ReachabilityIndicator: require('/app/components/Dependencies/Common/ReachabilityIndicator.vue').default,FixabilityIndicator: require('/app/components/Dependencies/Common/FixabilityIndicator.vue').default,DynamicRiskIndicator: require('/app/components/Dependencies/Common/DynamicRiskIndicator.vue').default})
